<lib-date-range-field
  [ngModel]="rango()"
  [startLabelKey]="rotuloInicio()"
  [endLabelKey]="rotuloFin()"
  [referenceDate]="systemDate()"
  [showPeriodName]="periodName()"
  [showDuration]="duration()"
  [minDate]="minDate()"
  [maxDate]="maxDate() ?? maxDateModel() ?? null"
  (ngModelChange)="alElegirRango($event)"
/>
